export default "__VITE_ASSET__CTzMncGl__"